import { render, staticRenderFns } from "./UploadFilesList.vue?vue&type=template&id=5120c0a7&scoped=true&lang=html&"
import script from "./UploadFilesList.vue?vue&type=script&lang=js&"
export * from "./UploadFilesList.vue?vue&type=script&lang=js&"
import style0 from "./UploadFilesList.vue?vue&type=style&index=0&id=5120c0a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5120c0a7",
  null
  
)

export default component.exports